module.exports = __webpack_public_path__ + "static/media/siddharth-chikmagalur-trip-06.5da8043e.png";